import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styles from './Toast.module.scss';
const Toast = ({ message, isVisible, onClose, duration = 3000 }) => {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [isVisible, duration, onClose]);
    if (!isVisible)
        return null;
    return (_jsx("div", { className: `${styles.toast} ${isVisible ? styles.toast__visible : ''}`, children: _jsxs("div", { className: styles.toast__content, children: [_jsx("span", { className: styles.toast__message, children: message }), _jsx("button", { className: styles.toast__close, onClick: onClose, "aria-label": "Close notification", children: "\u00D7" })] }) }));
};
export default Toast;
